export type ChatContactPickSource = 'you' | 'contact';

export type ChatContactPickItem = {
  key: string;
  source: ChatContactPickSource;
  fullName: string;
  phoneNumber: string;
  avatarUrl?: string | null;
  organization?: string;
  email?: string;
};

export function digitsOnly(value: string): string {
  return value.replace(/\D/g, '');
}

export function resolveContactPhone(contact: {
  phone?: string | null;
  whatsapp?: string | null;
}): string | null {
  const raw = contact.whatsapp || contact.phone || '';
  const digits = digitsOnly(raw);
  return digits.length > 0 ? digits : null;
}

export function toPickItemsFromContacts(
  contacts: Array<{
    id: string;
    name: string;
    phone?: string | null;
    whatsapp?: string | null;
    company?: string | null;
    email?: string | null;
    profile_picture_url?: string | null;
  }>,
): ChatContactPickItem[] {
  const out: ChatContactPickItem[] = [];
  for (const c of contacts) {
    const phoneNumber = resolveContactPhone(c);
    if (!phoneNumber) continue;
    out.push({
      key: `contact:${c.id}`,
      source: 'contact',
      fullName: c.name,
      phoneNumber,
      avatarUrl: c.profile_picture_url ?? null,
      organization: c.company?.trim() || undefined,
      email: c.email?.trim() || undefined,
    });
  }
  return out;
}

export function toYouPickItem(
  conn: { id: string; name: string; number: string; profilePhotoUrl?: string | null } | null | undefined,
): ChatContactPickItem | null {
  if (!conn) return null;
  const phoneNumber = digitsOnly(conn.number || '');
  if (!phoneNumber) return null;
  return {
    key: `you:${conn.id}`,
    source: 'you',
    fullName: conn.name || phoneNumber,
    phoneNumber,
    avatarUrl: conn.profilePhotoUrl ?? null,
  };
}

export function filterPickItems(items: ChatContactPickItem[], query: string): ChatContactPickItem[] {
  const q = query.trim().toLowerCase();
  if (!q) return items;
  const qDigits = digitsOnly(q);
  return items.filter((item) => {
    if (item.fullName.toLowerCase().includes(q)) return true;
    if (qDigits && item.phoneNumber.includes(qDigits)) return true;
    return false;
  });
}

export function pickItemToFormInput(item: ChatContactPickItem): {
  fullName: string;
  phoneNumber: string;
  organization?: string;
  email?: string;
} {
  return {
    fullName: item.fullName,
    phoneNumber: item.phoneNumber,
    ...(item.organization ? { organization: item.organization } : {}),
    ...(item.email ? { email: item.email } : {}),
  };
}
